import type { SanityProduct } from 'types/cms/SanityProduct';

export const removeExcludedProducts = (
  products: SanityProduct[],
  exclusions: string[],
): SanityProduct[] =>
  products?.filter((product) => !exclusions.includes(product.slug));
